export const isProduction = process.env.NODE_ENV === 'production';
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isStaging = process.env.REACT_APP_MODE === 'staging';
export const isLocal = process.env.REACT_APP_MODE === 'local';

export const BASE_URL: string = isLocal ? 'http://localhost:3000' : 'https://microservices.dev.rappi.com';

export const ENVIRONMENT_CODE: string = 'CO';

export const STATIC_TOKEN: string = '2647c9cb2943c9613b8d21af6072412c';

export const USER_TOKEN: string =
  'eyJpZCI6MSwibmFtZSI6IkRhdmlkIFJhbWlyZXoiLCJlbWFpbCI6ImRhdmlkLnJhbWlyZXpAcmFwcGkuY29tIiwicHJvZmlsZV9waWMiOm51bGwsImNvdW50cnlfY29kZSI6IiIsInVzZXJfZW5hYmxlZCI6dHJ1ZSwiYWxlcnRfZW5hYmxlZCI6ZmFsc2UsInBlcm1pc3Npb25zIjpbXSwic3VwcGxpZXJzIjpbMSwyLDNdfQ==';

export const JWT: string =
  'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Iko3NzRCbjB3Z0xhVVdpNktEeGZINSJ9.eyJnaXZlbl9uYW1lIjoiUml2YWxkbyBGYWJpbyIsImZhbWlseV9uYW1lIjoiRXN0ZWJhbiIsIm5pY2tuYW1lIjoicml2YWxkby5lc3RlYmFuIiwibmFtZSI6IlJpdmFsZG8gRmFiaW8gRXN0ZWJhbiIsInBpY3R1cmUiOiJodHRwczovL2xoMy5nb29nbGV1c2VyY29udGVudC5jb20vYS9BQWNIVHRkNDBUY0Y2MmJFUFA0cGhYSXVQaVRHUm5MTEdFZ01TdFRJa1pxOVYxS3QzUT1zOTYtYyIsImxvY2FsZSI6ImVzIiwidXBkYXRlZF9hdCI6IjIwMjMtMDctMjdUMTk6MDY6MDIuNTU0WiIsImVtYWlsIjoicml2YWxkby5lc3RlYmFuQHJhcHBpLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJpc3MiOiJodHRwczovL3R1cmJvLWRldi51cy5hdXRoMC5jb20vIiwiYXVkIjoiSFY0TncxZFROUTRoaGJZSms5emZPU2ZNb2lyUU1jNkYiLCJpYXQiOjE2OTA0ODQ3NjgsImV4cCI6MTY5MDUyMDc2OCwic3ViIjoiZ29vZ2xlLW9hdXRoMnwxMTcyNjY3NDgxNjQwNzM2MDUxNTEiLCJzaWQiOiJmSEF6Njd5eU9KSmo3V1Rrb1dRcUFPSy1tbXFJTk1HcyIsIm5vbmNlIjoiYjFkUFptZG5WakZRZVd0VWFrTkZUVWRUWm1jMFpINWZaM1ZmZHpKV09WbG5RMnBJWldaR2JqazFTUT09In0.ldrbMyFv1Wbp9dLa2CvkMuvxl8pH5wm6LoSuUkcKbrFeYkVJoqUGwQs0LqsOOt0MvmWvoklUdX6okVoPAo6kPQrY9Puq_wvinzXACywEi50dOy1XTzbzt6SE649rGP06rF4Ia-Kd2abKZI-Hzc7FyrLw8NigI4st3Cw33-iFYg0xTKKaoR4d-YXXk1yxRPc0QAo0vjT-4yNJfHeHrip8jD2cgBaASW7VHOC2I3DexDda9PFpdjLJTOPAvWvdZDfpr7e_tAkRXOLNsPG8WIQkqnXRAAwLH9ypIiYFAz28R41C71IZ-MTU-A-Ecyy3ve1bZjDSP-F1p9IxaAb-GZLpGg';

export const KEYS = {
  DIGIT: 'Digit',
  BACKSPACE: 'Backspace',
  ENTER: 'Enter'
};

export const SORT_STRATEGY: { [direction: string]: any } = {
  ascend: 'ASC',
  descend: 'DESC'
};

export const MESSAGE_DURATION = 4;
